import NewPurchaseReturn from "../../../../components/@documents/purchase_returns/NewPurchaseReturn";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PurchaseReturnNewPage() {

    return (
        <NewPurchaseReturn 
            routeType={routeTypes.retail}
        />
    )
}